// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Button from './Button';

// Styles
import './PillButton.scss';

const PillButton = ({ children, onClickFn, className }) => (
    <Button className={classNames('PillButton', className)} onClickFn={onClickFn}>
        {children}
    </Button>
);

PillButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onClickFn: PropTypes.func,
    className: PropTypes.string,
};

export default PillButton;
